/**
 * NoJobsScheduledMessage
 */
import React from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { Table } from 'semantic-ui-react';

// Selectors
import { selectNumberOfDays } from '../../../../selectors';

interface Props {
    numberOfDays: number;
}

export class NoJobsScheduledMessage extends React.PureComponent<Props> {
    render() {
        const { numberOfDays } = this.props;
        return (
            <Table.Row>
                <Table.Cell textAlign="center" colSpan={numberOfDays + 1}>
                    No jobs scheduled
                </Table.Cell>
            </Table.Row>
        );
    }
}

const mapStateToProps = createStructuredSelector({
    numberOfDays: selectNumberOfDays
});

export default connect(mapStateToProps)(NoJobsScheduledMessage);
